import { Typography } from '@mui/material';

interface PageHeaderProps {
  userName: string;
  jobTitle: string;
  pageTitle: string;
  description?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ userName, pageTitle, description }) => {
  return (
    <>
      <Typography variant="h3" component="h3" gutterBottom>
        {pageTitle}
      </Typography>
      <Typography variant="subtitle2">
        {userName}, welcome to the {pageTitle} panel.
      </Typography>
      {description && (
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      )}
    </>
  );
};

export default PageHeader;
